import {ApiClient, Endpoint} from "@eryxcoop/appyx-comm";
import GetCustomersResponse from "./GetCustomersResponse";
import MarkOrderAsPendingEndpoint from "./MarkOrderAsPendingEndpoint";
import MarkOrderAsPendingResponse from "./MarkOrderAsPendingResponse";
import GetArticlePriceListResponse from "./GetArticlePriceListResponse";
import GetCustomerArticlePriceListEndpoint from "./GetCustomerArticlePriceListEndpoint";
import DisableDateEndpoint from "././functionalities/home/DisableDateEndpoint";
import GetEnabledDeliveryDatesResponse from "./GetEnabledDeliveryDatesResponse";
import GetOrderOptionsResponse from "./GetOrderOptionsResponse";
import CreateAllowanceEndpoint from "./functionalities/allowances/create_allowance/CreateAllowanceEndpoint";
import AllowanceFormOptionsResponse from "./functionalities/allowances/create_allowance/AllowanceFormOptionsResponse";
import GetAllowancesResponse from "./functionalities/allowances/list_allowances/GetAllowancesResponse";
import CreateOrderEndpoint from "./functionalities/orders/create_order/CreateOrderEndpoint";
import CreateOrderResponse from "./functionalities/orders/create_order/CreateOrderResponse";
import CreateOrderErrorResponse from "./functionalities/orders/create_order/CreateOrderErrorResponse";
import GetOrdersResponse from "./functionalities/orders/list_orders/GetOrdersResponse";
import ConfirmOrdersOnDateEndpoint from "./functionalities/home/ConfirmOrdersOnDateEndpoint";
import GetOrderOptionsEndpoint from "./functionalities/orders/create_order/GetOrderOptionsEndpoint";
import LoginResponse from "./functionalities/login/LoginResponse";
import OrderResponse from "./functionalities/orders/OrderResponse";
import DeleteOrderEndpoint from "./DeleteOrderEndpoint";
import ImportInvoicesManuallyByDateEndpoint from "./functionalities/home/ImportInvoicesManuallyByDateEndpoint";
import GetPurchaseOrdersValidationResultsResponse
    from "./functionalities/purchase_order/GetPurchaseOrdersValidationResultsResponse";
import DeleteOrdersArticleEndpoint from "./functionalities/orders/DeleteOrdersArticleEndpoint";
import AddArticlesToOrderEndpoint from "./functionalities/orders/AddArticlesToOrderEndpoint";
import EditOrderEndpoint from "./functionalities/orders/EditOrderEndpoint";
import EditOrdersPurchaseOrderNumberEndpoint from "./functionalities/orders/EditOrdersPurchaseOrderNumberEndpoint";
import EditOrdersObservationsEndpoint from "./functionalities/orders/EditOrdersObservationsEndpoint";
import GetCurrentAccountsResponse
    from "./functionalities/current_accounts/list_current_accounts/GetCurrentAccountsResponse";
import GetKamDailyReportPreviewsResponse
    from "./functionalities/current_accounts/list_current_accounts/GetKamDailyReportPreviewsResponse";
import SendKamDailyReportsResponse
    from "./functionalities/current_accounts/list_current_accounts/SendKamDailyReportsResponse";
import GetPaymentReminderPreviewEndpoint
    from "./functionalities/current_accounts/payment_reminder/GetPaymentReminderPreviewEndpoint";
import GetPaymentReminderPreviewResponse
    from "./functionalities/current_accounts/payment_reminder/GetPaymentReminderPreviewResponse";
import SendPaymentReminderEndpoint
    from "./functionalities/current_accounts/payment_reminder/SendPaymentReminderEndpoint";
import SendPaymentReminderResponse
    from "./functionalities/current_accounts/payment_reminder/SendPaymentReminderResponse";
import PaymentReminderErrorResponse
    from "./functionalities/current_accounts/payment_reminder/PaymentReminderErrorResponse";
import GetPortfolioAgingResponse
    from "./functionalities/current_accounts/list_current_accounts/portfolio_aging/GetPortfolioAgingResponse";
import GetPortfolioAgingTopDebtorsResponse
    from "./functionalities/current_accounts/list_current_accounts/portfolio_aging/GetPortfolioAgingTopDebtorsResponse";
import GetPortfolioAgingTopDebtorsEndpoint
    from "./functionalities/current_accounts/list_current_accounts/portfolio_aging/GetPortfolioAgingTopDebtorsEndpoint";
import DownloadedFileResponse from "./DownloadedFileResponse";
import CurrentAccountAndAccountingDocumentsResponse
    from "./functionalities/current_accounts/CurrentAccountAndAccountingDocumentsResponse";
import CustomerDebtAlertResponse from "./functionalities/orders/CustomerDebtAlertResponse";
import EditCurrentAccountRiskClassificationResponse
    from "./functionalities/current_accounts/EditCurrentAccountRiskClassificationResponse";
import EditCurrentAccountRiskClassificationEndpoint
    from "./functionalities/current_accounts/EditCurrentAccountRiskClassificationEndpoint";
import RequestJudicialStageAdvanceResponse
    from "./functionalities/current_accounts/RequestJudicialStageAdvanceResponse";
import RequestJudicialStageAdvanceEndpoint
    from "./functionalities/current_accounts/RequestJudicialStageAdvanceEndpoint";
import URLResponse from "./utils/URLResponse";
import GetMarketplaceUsersResponse from "./functionalities/users/list_marketplace_users/GetMarketplaceUsersResponse";
import CreateUserResponse from "./functionalities/users/create_user/CreateUserResponse";
import CreateUserErrorResponse from "./functionalities/users/create_user/CreateUserErrorResponse";
import AllRolesResponse from "./functionalities/users/assign_roles/AllRolesResponse";
import UserResponse from "./functionalities/users/assign_roles/UserResponse";
import DeliverySitesResponse from "./DeliverySitesResponse";
import UpdateUserRolesEndpoint from "./functionalities/users/assign_roles/UpdateUserRolesEndpoint";
import GetArticlePriceListErrorResponse from "./GetArticlePriceListErrorResponse";
import SynchronizeOrderStatesManuallyByDateEndpoint
    from "./functionalities/home/synchronizeOrderStatesManuallyByDateEndpoint";
import AllAuthorizationsResponse from "./functionalities/authorizations/AllAuthorizationsResponse";
import AuthorizationResponse from "./functionalities/authorizations/AuthorizationResponse";
import OrderLogResponse from "./functionalities/orders/OrderLogResponse";
import DatedEndpoint from "./functionalities/home/DatedEndpoint";
import DateAdapter from "./adapters/DateAdapter";
import GetBackofficeUsersResponse from "./functionalities/users/list_backoffice_users/GetBackofficeUsersResponse";
import InvalidDomainForUserErrorResponse from "./functionalities/users/create_user/InvalidDomainForUserErrorResponse";
import AllPermissionsResponse from "./functionalities/users/permissions/AllPermissionsResponse";
import CustomerGroupsResponse from "./functionalities/customer_groups/CustomerGroupsResponse";
import UpdateUserEndpoint from "./functionalities/users/permissions/UpdateUserEndpoint";
import CustomerOnboardingsResponse from "./functionalities/customer_onboarding/CustomerOnboardingsResponse";

import UpdateAuthorizationsEndpoint from "./functionalities/authorizations/UpdateAuthorizationsEndpoint";
import ExpiredActionRequestOfAuthorizationErrorResponse
    from "./functionalities/authorizations/ExpiredActionRequestOfAuthorizationErrorResponse";
import OrderWithAuthorizationAndPaymentProofResponse from "./functionalities/orders/OrderWithAuthorizationAndPaymentProofResponse";
import GetOrdersWithAuthorizationsStatesResponse
    from "./functionalities/orders/list_orders/GetOrdersWithAuthorizationsStatesResponse";
import CustomerOnboardingResponse from "./functionalities/customer_onboarding/CustomerOnboardingResponse";
import CreateCustomerOnboardingErrorResponse from "./CreateCustomerOnboardingErrorResponse";
import PriceListsResponse from "./PriceListsResponse";
import PaymentTermsResponse from "./PaymentTermsResponse";
import EditCustomerOnboardingLegalEntityEndpoint
    from "./functionalities/customer_onboarding/edition/EditCustomerOnboardingLegalEntityEndpoint";
import EditCustomerOnboardingCommercialTermsEndpoint
    from "./functionalities/customer_onboarding/edition/EditCustomerOnboardingCommercialTermsEndpoint";
import EditCustomerOnboardingContactDataEndpoint
    from "./functionalities/customer_onboarding/edition/EditCustomerOnboardingContactDataEndpoint";
import EditOrCreateCustomerOnboardingDeliverySiteOnboardingRequestEndpoint
    from "./functionalities/customer_onboarding/edition/EditOrCreateCustomerOnboardingDeliverySiteOnboardingRequestEndpoint";
import EditOrCreateCustomerOnboardingUserRequestEndpoint
    from "./functionalities/customer_onboarding/edition/EditOrCreateCustomerOnboardingUserOnboardingRequestEndpoint";
import UpdateCustomerOnboardingStateErrorResponse from "./UpdateCustomerOnboardingStateErrorResponse";
import OrderPricesResponse from "./functionalities/authorizations/OrderPricesResponse";
import OrderAdvancePaymentProofResponse from "./functionalities/authorizations/OrderAdvancePaymentProofResponse";
import ImportSalesBudgetResponse from "./functionalities/budget/ImportSalesBudgetResponse";
import ImportInflationForecastResponse from "./functionalities/budget/ImportInflationForecastResponse";
import GetBudgetForYearResponse from "./functionalities/budget/GetBudgetForYearResponse";
import CustomerDeliverySitesResponse from "./CustomerDeliverySitesResponse";
import CustomerDeliverySiteOnboardingsResponse from "./CustomerDeliverySiteOnboardingsResponse";
import UserDoesNotHaveRequiredPermissionErrorResponse
    from "./functionalities/customer_groups/UserDoesNotHaveRequiredPermissionErrorResponse";
import DeliverySiteOnboardingResponse
    from "./functionalities/delivery_site_onboarding/DeliverySiteOnboardingResponse";
import GrossIncomeTaxProfileResponse from "./GrossIncomeTaxProfileResponse";
import EditCustomerCollectionsEmailResponse from "./EditCustomerCollectionsEmailResponse";
import EditCustomerCollectionsEmailEndpoint from "./EditCustomerCollectionsEmailEndpoint";
import CustomerContactsResponse from "./CustomerContactsResponse";
import AskBackofficeAssistantResponse from "./functionalities/chat_widget/AskBackofficeAssistantResponse";
import AdvancePaymentProofRequiredErrorResponse from "./functionalities/orders/AdvancePaymentProofRequiredErrorResponse";
import MarkOrderAsPendingErrorResponse from "./functionalities/orders/MarkOrderAsPendingErrorResponse";
import DailySalesProgressResponse from "./functionalities/dashboard/DailySalesProgressResponse";
import SalesByChannelResponse from "./functionalities/dashboard/SalesByChannelResponse";
import SalesByCustomerResponse from "./functionalities/dashboard/SalesByCustomerResponse";
import PurchaseFrequencyResponse from "./functionalities/dashboard/PurchaseFrequencyResponse";
import SalesByArticleCategoryResponse from "./functionalities/dashboard/SalesByArticleCategoryResponse";
import SalesByArticleResponse from "./functionalities/dashboard/SalesByArticleResponse";
import SalesByDestinationResponse from "./functionalities/dashboard/SalesByDestinationResponse";
import SummaryKpisResponse from "./functionalities/dashboard/SummaryKpisResponse";
import FilterDateChannelAndCategoriesEndpoint from "./functionalities/dashboard/FilterDateChannelAndCategoriesEndpoint";
import SoldBoxesByCustomerAndArticleEndpoint from "./functionalities/operations/sold_boxes_by_customer_and_article/SoldBoxesByCustomerAndArticleEndpoint";
import SoldBoxesByCustomerAndArticleResponse from "./functionalities/operations/sold_boxes_by_customer_and_article/SoldBoxesByCustomerAndArticleResponse";
import DashboardChannelsResponse from "./functionalities/dashboard/DashboardChannelsResponse";
import DashboardArticleCategoriesResponse from "./functionalities/dashboard/DashboardArticleCategoriesResponse";
import CreateLeadEndpoint from "./functionalities/crm/create_lead/CreateLeadEndpoint";
import LeadResponse from "./functionalities/crm/create_lead/LeadResponse";
import PossibleDuplicateLeadsEndpoint from "./functionalities/crm/create_lead/PossibleDuplicateLeadsEndpoint";
import PossibleDuplicateLeadsResponse from "./functionalities/crm/create_lead/PossibleDuplicateLeadsResponse";
import CreateLeadErrorResponse from "./functionalities/crm/create_lead/CreateLeadErrorResponse";
import AssignLeadEndpoint from "./functionalities/crm/lead_assignment_queue/AssignLeadEndpoint";
import AssignLeadErrorResponse from "./functionalities/crm/lead_assignment_queue/AssignLeadErrorResponse";
import LeadAssignmentQueueResponse from "./functionalities/crm/lead_assignment_queue/LeadAssignmentQueueResponse";
import DeliveryZoneResponse from "./functionalities/crm/create_lead/DeliveryZoneResponse";
import LeadTaxpayerIdentificationNumberValidationResponse from "./functionalities/crm/create_lead/LeadTaxpayerIdentificationNumberValidationResponse";


export default class SaporeApiClient extends ApiClient{
    constructor(requester, authenticationMethod, application) {
        super(requester);
        this._authenticationMethod = authenticationMethod;
        this._application = application;
    }

    getCustomers(responseHandler) {
        const endpoint = new Endpoint({
            url: "customers/all",
            method: "GET",
            ownResponses: [GetCustomersResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getOrderOptions(partialOrder, responseHandler) {
        const endpoint = new GetOrderOptionsEndpoint({
            url: "order-fields-options",
            method: "POST",
            ownResponses: [GetOrderOptionsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, partialOrder, responseHandler);
    }

    getPurchaseOrdersValidationResults(responseHandler) {
        const endpoint = new Endpoint({
            url: "purchase-order-results",
            method: "GET",
            ownResponses: [GetPurchaseOrdersValidationResultsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    retryPurchaseOrdersValidationProcess(responseHandler) {
        const endpoint = new Endpoint({
            url: "purchase-orders/retry",
            method: "POST",
            ownResponses: [],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getCurrentAccounts(responseHandler) {
        const endpoint = new Endpoint({
            url: "current-accounts",
            method: "GET",
            ownResponses: [GetCurrentAccountsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getKamDailyReportPreviews(responseHandler) {
        const endpoint = new Endpoint({
            url: "current-accounts/kam-daily-report-previews",
            method: "GET",
            ownResponses: [GetKamDailyReportPreviewsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    sendKamDailyReportsManually(responseHandler) {
        const endpoint = new Endpoint({
            url: "current-accounts/kam-daily-reports/send-manually",
            method: "POST",
            ownResponses: [SendKamDailyReportsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getPaymentReminderPreview(taxpayerIdentificationNumber, responseHandler) {
        const endpoint = new GetPaymentReminderPreviewEndpoint({
            url: "current-accounts/payment-reminder-preview",
            method: "GET",
            ownResponses: [GetPaymentReminderPreviewResponse, PaymentReminderErrorResponse,
                UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber}, responseHandler);
    }

    sendPaymentReminder(taxpayerIdentificationNumber, message, responseHandler) {
        const endpoint = new SendPaymentReminderEndpoint({
            url: "customer/payment-reminder",
            method: "POST",
            ownResponses: [SendPaymentReminderResponse, PaymentReminderErrorResponse,
                UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, message}, responseHandler);
    }

    getPortfolioAging(responseHandler) {
        const endpoint = new Endpoint({
            url: "current-accounts/aging",
            method: "GET",
            ownResponses: [GetPortfolioAgingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getPortfolioAgingTopDebtors(tierCode, responseHandler) {
        const endpoint = new GetPortfolioAgingTopDebtorsEndpoint({
            url: "current-accounts/aging/top-debtors",
            method: "GET",
            ownResponses: [GetPortfolioAgingTopDebtorsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {tierCode}, responseHandler);
    }

    currentAccountAndAccountingDocuments(customersBusinessName, responseHandler) {
        const endpoint = new Endpoint({
            url: `current-account/${encodeURIComponent(customersBusinessName)}`,
            method: "GET",
            ownResponses: [CurrentAccountAndAccountingDocumentsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': customersBusinessName}, responseHandler);
    }

    exportCurrentAccountPrimaryRecord(businessName, responseHandler) {
        const endpoint = new Endpoint({
            url: 'current-account/primary-record/export',
            method: "GET",
            ownResponses: [DownloadedFileResponse],
            needsAuthorization: true
        });
        return this.downloadEndpoint(endpoint, {'business_name': businessName}, responseHandler);
    }

    exportAllowancesCreditNotes(month, responseHandler) {
        const endpoint = new Endpoint({
            url: 'allowances/credit-notes/export',
            method: "GET",
            ownResponses: [DownloadedFileResponse],
            needsAuthorization: true
        });
        return this.downloadEndpoint(endpoint, {'month': month}, responseHandler);
    }

    async downloadEndpoint(endpoint, values, customResponseHandler) {
        try {
            const response = await this._requester.download({endpoint: endpoint, data: endpoint.adaptValues(values)});
            return this._handleResponseForRequest(response, endpoint, values, customResponseHandler);
        } catch (exception) {
            return this._handleException(exception);
        }
    }

    customerDebtAlert(customersBusinessName, responseHandler) {
        const endpoint = new Endpoint({
            url: `customer/${encodeURIComponent(customersBusinessName)}/debt-alert`,
            method: "GET",
            ownResponses: [CustomerDebtAlertResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    editCurrentAccountRiskClassification(responseHandler, businessName, highRisk) {
        const endpoint = new EditCurrentAccountRiskClassificationEndpoint({
            url: `current-account/${encodeURIComponent(businessName)}/overdue-tolerance/edit`,
            method: "POST",
            ownResponses: [EditCurrentAccountRiskClassificationResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {isHighRisk: highRisk}, responseHandler);
    }

    requestJudicialStageAdvance(businessName, reason, responseHandler) {
        const endpoint = new RequestJudicialStageAdvanceEndpoint({
            url: "customer/judicial-stage-advance-requests",
            method: "POST",
            ownResponses: [RequestJudicialStageAdvanceResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {businessName, reason}, responseHandler);
    }

    fileURLForAccountingDocumentWith(type, number, pointOfSale, responseHandler) {
    const endpoint = new Endpoint({
        url: `accounting-document/${type}/${number}/${pointOfSale}/file`,
        method: "GET",
        ownResponses: [URLResponse],
        needsAuthorization: true
    });
    return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getOrders(responseHandler, fromDate, toDate) {
        const dateAdapter = new DateAdapter()
        const fromDateAdapted = dateAdapter.adapt(fromDate)
        const toDateAdapted = dateAdapter.adapt(toDate)
        const endpoint = new Endpoint({
            url: `orders/${fromDateAdapted}/${toDateAdapted}`,
            method: "GET",
            ownResponses: [GetOrdersWithAuthorizationsStatesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getDailySalesProgress(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/daily-sales-progress",
            method: "GET",
            ownResponses: [DailySalesProgressResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getSalesByChannel(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/sales-by-channel",
            method: "GET",
            ownResponses: [SalesByChannelResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getSalesByCustomer(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/sales-by-customer",
            method: "GET",
            ownResponses: [SalesByCustomerResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getSalesByArticleCategory(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/sales-by-article-category",
            method: "GET",
            ownResponses: [SalesByArticleCategoryResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getSalesByArticle(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/sales-by-article",
            method: "GET",
            ownResponses: [SalesByArticleResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getSoldBoxesByCustomerAndArticle(responseHandler, fromDate, toDate) {
        const endpoint = new SoldBoxesByCustomerAndArticleEndpoint({
            url: "operations/sold-boxes-by-customer-and-article",
            method: "GET",
            ownResponses: [SoldBoxesByCustomerAndArticleResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate }, responseHandler);
    }

    getSalesByDestination() {
        // MOCK TEMPORAL: `dashboard/sales-by-destination` todavía no existe; devolvemos la
        // respuesta por defecto (incluye cajas). Cuando el endpoint exista, cambiar por un
        // callEndpoint con responseHandler como el resto de los métodos del dashboard:
        // const endpoint = new FilterDateChannelAndCategoriesEndpoint({
        //     url: "dashboard/sales-by-destination", method: "GET",
        //     ownResponses: [SalesByDestinationResponse], needsAuthorization: true,
        // });
        // return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
        return SalesByDestinationResponse.asDefaultResponse();
    }

    getSummaryKpis(responseHandler, fromDate, toDate, channels = [], categories = []) {
        const endpoint = new FilterDateChannelAndCategoriesEndpoint({
            url: "dashboard/summary-kpis",
            method: "GET",
            ownResponses: [SummaryKpisResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, { fromDate, toDate, channels, categories }, responseHandler);
    }

    getPurchaseFrequency(responseHandler) {
        const endpoint = new Endpoint({
            url: "dashboard/purchase-frequency",
            method: "GET",
            ownResponses: [PurchaseFrequencyResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getDashboardChannels(responseHandler) {
        const endpoint = new Endpoint({
            url: "dashboard/channels",
            method: "GET",
            ownResponses: [DashboardChannelsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getDashboardArticleCategories(responseHandler) {
        const endpoint = new Endpoint({
            url: "dashboard/article-categories",
            method: "GET",
            ownResponses: [DashboardArticleCategoriesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    createOrder(order, responseHandler) {
        const endpoint = new CreateOrderEndpoint({
            url: "order/create",
            method: "POST",
            ownResponses: [CreateOrderResponse, CreateOrderErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, order, responseHandler);
    }

    createAllowance(payload, responseHandler) {
        const endpoint = new CreateAllowanceEndpoint({
            url: "allowances/create",
            method: "POST",
            ownResponses: [],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, payload, responseHandler);
    }

    allowanceFormOptions(responseHandler) {
        const endpoint = new Endpoint({
            url: "allowances/options",
            method: "GET",
            ownResponses: [AllowanceFormOptionsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    allowances(responseHandler) {
        const endpoint = new Endpoint({
            url: "allowances",
            method: "GET",
            ownResponses: [GetAllowancesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getOrder(orderId, responseHandler) {
        const endpoint = new Endpoint({
            url: `order/backoffice/${orderId}`,
            method: "GET",
            ownResponses: [OrderWithAuthorizationAndPaymentProofResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    markOrderAsPending(orderNumber, responseHandler) {
        const endpoint = new MarkOrderAsPendingEndpoint({
            url: "order/mark-as-pending",
            method: "POST",
            ownResponses: [MarkOrderAsPendingResponse, AdvancePaymentProofRequiredErrorResponse, MarkOrderAsPendingErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, orderNumber, responseHandler);
    }

    async registerAdvancePaymentProof(orderNumber, file, responseHandler) {
        const formData = new FormData();
        if (file) {
            formData.append('files', file);
        }
        const endpointUrl = `/order/${orderNumber}/register-advance-payment-proof/`;
        const method = 'POST';
        const responseClass = OrderAdvancePaymentProofResponse;
        return await this.callEndpointWithFiles(endpointUrl, method, formData, responseClass, responseHandler);
    }

    async importSalesBudget(year, file, responseHandler) {
        const formData = new FormData();
        formData.append('year', year);
        if (file) {
            formData.append('file', file);
        }
        const endpointUrl = `/budget/sales-forecast/import/`;
        const method = 'POST';
        const responseClass = ImportSalesBudgetResponse;
        return await this.callEndpointWithFiles(endpointUrl, method, formData, responseClass, responseHandler);
    }

    async importInflationForecast(year, file, responseHandler) {
        const formData = new FormData();
        formData.append('year', year);
        if (file) {
            formData.append('file', file);
        }
        const endpointUrl = `/budget/inflation-forecast/import/`;
        const method = 'POST';
        const responseClass = ImportInflationForecastResponse;
        return await this.callEndpointWithFiles(endpointUrl, method, formData, responseClass, responseHandler);
    }

    getBudgetForYear(year, responseHandler) {
        const endpoint = new Endpoint({
            url: `budget/${year}/`,
            method: "GET",
            ownResponses: [GetBudgetForYearResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    returnOrderToInitial(orderNumber, responseHandler) {
        const endpoint = new MarkOrderAsPendingEndpoint({
            url: "order/return-to-initial",
            method: "POST",
            ownResponses: [MarkOrderAsPendingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, orderNumber, responseHandler);
    }

    getCustomerArticlePriceList(customerBusinessName, responseHandler) {
        const endpoint = new GetCustomerArticlePriceListEndpoint({
            url: `customer/${customerBusinessName}/article-price-list`,
            method: "GET",
            ownResponses: [GetArticlePriceListResponse, GetArticlePriceListErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, customerBusinessName, responseHandler);
    }

    disableDate(date, responseHandler) {
        const endpoint = new DisableDateEndpoint({
            url: 'disabled-date/add',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    importInvoicesManuallyByDate(date, responseHandler) {
        const endpoint = new ImportInvoicesManuallyByDateEndpoint({
            url: 'invoices/put-in-box-by-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeInvoicesManuallyByDate(date, responseHandler) {
        const endpoint = new ImportInvoicesManuallyByDateEndpoint({
            url: 'erp/invoices/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeOrderStatesManuallyForDate(date, responseHandler) {
        const endpoint = new SynchronizeOrderStatesManuallyByDateEndpoint({
            url: 'erp/order/synchronize-order-states-by-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeAccountingDocumentsManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/accounting-documents/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeDocumentApplicationsManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/document-applications/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeCreditNotesManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/credit-notes/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeReceiptsManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/accounting-documents/receipts/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeDebitNotesManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/accounting-documents/debit-notes/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeWitholdingCertificatesManuallyForDate(date, responseHandler) {
        const endpoint = new DatedEndpoint({
            url: 'erp/accounting-documents/witholding-certificates/synchronize-for-date',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    synchronizeAdjustments(responseHandler) {
        const endpoint = new Endpoint({
            url: 'erp/accounting-documents/adjustments/synchronize',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    synchronizeWithERP(responseHandler) {
        const endpoint = new Endpoint({
            url: 'erp/synchronize',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    recalculateCurrentAccounts(responseHandler) {
        const endpoint = new Endpoint({
            url: 'current-account/recalculate-all-balances',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    emailMissingApplicationDocuments(responseHandler) {
        const endpoint = new Endpoint({
            url: 'erp/document-applications/email-missing-documents',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    confirmOrdersOn(date, responseHandler) {
        const endpoint = new ConfirmOrdersOnDateEndpoint({
            url: 'confirm-orders',
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, date, responseHandler)
    }

    allAuthorizations(responseHandler) {
        const endpoint = new Endpoint({
            url: 'authorizations',
            ownResponses: [AllAuthorizationsResponse],
            method: "GET",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    getAuthorization(authorizationId, responseHandler) {
        const endpoint = new Endpoint({
            url: `authorization/${authorizationId}`,
            ownResponses: [AuthorizationResponse],
            method: "GET",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {}, responseHandler)
    }

    approveAuthorization(authorizationId, observations, responseHandler) {
        const endpoint = new UpdateAuthorizationsEndpoint({
            url: `authorizations/approve`,
            ownResponses: [AllAuthorizationsResponse, ExpiredActionRequestOfAuthorizationErrorResponse],
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {'authorizations_ids': [authorizationId], "observations": observations}, responseHandler)
    }

    denyAuthorization(authorizationId, observations, responseHandler) {
        const endpoint = new UpdateAuthorizationsEndpoint({
            url: `authorizations/deny`,
            ownResponses: [AllAuthorizationsResponse, ExpiredActionRequestOfAuthorizationErrorResponse],
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {'authorizations_ids': [authorizationId], "observations": observations}, responseHandler)
    }

    requiresChanges(authorizationId, observations, responseHandler) {
        const endpoint = new UpdateAuthorizationsEndpoint({
            url: `authorizations/requires_changes`,
            ownResponses: [AllAuthorizationsResponse, ExpiredActionRequestOfAuthorizationErrorResponse],
            method: "POST",
            needsAuthorization: true
        })
        return this.callEndpoint(endpoint, {'authorizations_ids': [authorizationId], "observations": observations}, responseHandler)
    }

    getEnabledDatesForDeliverySite(deliverySiteCode, customerBusinessName, purchaseOrderNumber, orderNumber, responseHandler) {
        const url = `delivery_site/${deliverySiteCode}/${customerBusinessName}/enabled-dates-without-orders`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [GetEnabledDeliveryDatesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'purchase_order_number': purchaseOrderNumber, 'order_number': orderNumber}, responseHandler);
    }

    getEnabledDatesForFreeOrderDeliverySite(deliverySiteCode, customerBusinessName, responseHandler) {
        const url = `delivery_site/${deliverySiteCode}/${customerBusinessName}/enabled-dates-for-free-order`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [GetEnabledDeliveryDatesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    ordersForSamePurchaseOrderNumberAndDeliverySite(deliverySiteCode, customerBusinessName, purchaseOrderNumber, responseHandler) {
        const url = 'order/orders_with_same_purchase_order_number_and_delivery_site'
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [GetOrdersResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'purchase_order_number': purchaseOrderNumber,
                                                    'delivery_site_code': deliverySiteCode,
                                                    "business_name": customerBusinessName}, responseHandler);
    }

    addArticlesToOrder(orderNumber, articles, responseHandler) {
        const endpoint = new AddArticlesToOrderEndpoint({
            url: "order/articles/add-or-update",
            method: "POST",
            ownResponses: [MarkOrderAsPendingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {orderNumber, articles}, responseHandler);
    }

    deleteOrdersArticle(orderNumber, articleCode, responseHandler) {
        const endpoint = new DeleteOrdersArticleEndpoint({
            url: "order/articles/delete",
            method: "POST",
            ownResponses: [MarkOrderAsPendingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {orderNumber, articleCode}, responseHandler);
    }

    deleteOrder(orderNumber, observations, responseHandler) {
        const endpoint = new DeleteOrderEndpoint({
            url: "order/delete",
            method: "POST",
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {orderNumber, observations}, responseHandler);
    }

    editOrder(ordersNumber, order, responseHandler) {
        const endpoint = new EditOrderEndpoint({
            url: "order/edit",
            method: "POST",
            ownResponses: [OrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {ordersNumber, order}, responseHandler);
    }

    editOrdersPurchaseOrderNumber(ordersNumber, purchaseOrdersNumber, responseHandler) {
        const endpoint = new EditOrdersPurchaseOrderNumberEndpoint({
            url: "order/edit-purchase-order-number",
            method: "POST",
            ownResponses: [OrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {ordersNumber, purchaseOrdersNumber}, responseHandler);
    }

    editOrdersObservations(orderNumber, observations, responseHandler) {
        const endpoint = new EditOrdersObservationsEndpoint({
            url: "order/edit-observations",
            method: "POST",
            ownResponses: [OrderResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {orderNumber, observations}, responseHandler);
    }

    orderLog(orderNumber, responseHandler) {
        const endpoint = new Endpoint({
            url: `order/log/${orderNumber}`,
            method: "GET",
            ownResponses: [OrderLogResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'order_id' : orderNumber}, responseHandler);
    }

    getMarketplaceUsers(responseHandler) {
        const endpoint = new Endpoint({
            url: "users/marketplace",
            method: "GET",
            ownResponses: [GetMarketplaceUsersResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getBackofficeUsers(responseHandler) {
        const endpoint = new Endpoint({
            url: "users/backoffice",
            method: "GET",
            ownResponses: [GetBackofficeUsersResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    createUser(user, responseHandler) {
        const endpoint = new Endpoint({
            url: "user/create",
            method: "POST",
            ownResponses: [CreateUserResponse, CreateUserErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, user, responseHandler);
    }

    createBackofficeUser(user, responseHandler) {
        const endpoint = new Endpoint({
            url: "user/backoffice/create",
            method: "POST",
            ownResponses: [CreateUserResponse, InvalidDomainForUserErrorResponse, CreateUserErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, user, responseHandler);
    }

    async createUserOnAuthenticationMethod(email){
        return this._authenticationMethod.createUser(email)
    }

    recoverPassword(email, responseHandler) {
        const endpoint = new Endpoint({
            url: "user/recover-password",
            method: "POST",
            needsAuthorization: false
        });
        return this.callEndpoint(endpoint, {email}, responseHandler);
    }

    async login(email, password, responseHandler) {
        const endpoint = new Endpoint({
            url: "backoffice/login",
            method: "POST",
            ownResponses: [LoginResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {email, password}, responseHandler);
    }

    async signInOnAuthenticationMethod(email, password) {
        const response = await this._authenticationMethod.signIn(email, password);
        if(!response.hasErrors()) {
            this._application.session().addToken(response.token())
        }
        return response
    }

    updateUserRoles(userEmail, deliverySites, roles, responseHandler) {
        const endpoint = new UpdateUserRolesEndpoint({
            url: "users/update-roles/",
            method: "POST",
            ownResponses: [UserResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {userEmail, deliverySites, roles}, responseHandler);
    }

    editUser(userEmail, permissions, customersGroups, responseHandler) {
        const endpoint = new UpdateUserEndpoint({
            url: "users/edit-user/",
            method: "POST",
            ownResponses: [UserResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {userEmail, permissions, customersGroups}, responseHandler);
    }

    allRoles(responseHandler) {
        const endpoint = new Endpoint({
            url: "roles",
            method: "GET",
            ownResponses: [AllRolesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    allPermissions(responseHandler) {
        const endpoint = new Endpoint({
            url: "permissions",
            method: "GET",
            ownResponses: [AllPermissionsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    customerGroups(responseHandler) {
        const endpoint = new Endpoint({
            url: "customer_groups",
            method: "GET",
            ownResponses: [CustomerGroupsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    priceLists(responseHandler) {
        const endpoint = new Endpoint({
            url: "article-price-lists",
            method: "GET",
            ownResponses: [PriceListsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    paymentTerms(responseHandler) {
        const endpoint = new Endpoint({
            url: "payment-terms",
            method: "GET",
            ownResponses: [PaymentTermsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    deliverySitesForCustomers(responseHandler, customers) {
        const endpoint = new Endpoint({
            url: "customers/delivery_sites",
            method: "POST",
            ownResponses: [DeliverySitesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {customers}, responseHandler);
    }

    customerDeliverySites(responseHandler, businessName) {
        const endpoint = new Endpoint({
            url: `customer/delivery-sites/backoffice`,
            method: "GET",
            ownResponses: [CustomerDeliverySitesResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': businessName}, responseHandler);
    }

    customerDeliverySiteOnboardings(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: "customer/delivery-site-onboardings/backoffice",
            method: "GET",
            ownResponses: [CustomerDeliverySiteOnboardingsResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(
            endpoint,
            {'taxpayer_identification_number': taxpayerIdentificationNumber},
            responseHandler
        );
    }

    grossIncomeTaxProfileOfCustomer(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: "customer/gross-income-tax-profile",
            method: "GET",
            ownResponses: [GrossIncomeTaxProfileResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(
            endpoint,
            {'taxpayer_identification_number': taxpayerIdentificationNumber},
            responseHandler
        );
    }

    editCustomerCollectionsEmail(responseHandler, taxpayerIdentificationNumber, collectionsEmail) {
        const endpoint = new EditCustomerCollectionsEmailEndpoint({
            url: "customer/collections-email/edit",
            method: "POST",
            ownResponses: [EditCustomerCollectionsEmailResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, collectionsEmail}, responseHandler);
    }

    customerContacts(responseHandler, businessName) {
        const endpoint = new Endpoint({
            url: `customer/${businessName}/contacts`,
            method: "GET",
            ownResponses: [CustomerContactsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'business_name': businessName}, responseHandler);
    }

    async editCm01AndCm05Forms(responseHandler, taxpayerIdentificationNumber, cm01Form, cm05Form) {
        const formData = new FormData();
        formData.append('taxpayer_identification_number', taxpayerIdentificationNumber);
        if (cm01Form instanceof File) {
            formData.append('cm01_form', cm01Form);
        }
        if (cm05Form instanceof File) {
            formData.append('cm05_form', cm05Form);
        }
        return await this.callEndpointWithFiles(
            '/customer-onboarding/cm-forms/upload', 'POST', formData, GrossIncomeTaxProfileResponse, responseHandler
        );
    }

    deleteCm01Form(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: "customer-onboarding/cm01-form/delete",
            method: "POST",
            ownResponses: [GrossIncomeTaxProfileResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(
            endpoint,
            {'taxpayer_identification_number': taxpayerIdentificationNumber},
            responseHandler
        );
    }

    deleteCm05Form(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: "customer-onboarding/cm05-form/delete",
            method: "POST",
            ownResponses: [GrossIncomeTaxProfileResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(
            endpoint,
            {'taxpayer_identification_number': taxpayerIdentificationNumber},
            responseHandler
        );
    }

    createDeliverySiteOnboarding(customerBusinessName, deliverySiteOnboardingRequest, responseHandler) {
        const endpoint = new Endpoint({
            url: "delivery-site-onboarding/create",
            method: "POST",
            ownResponses: [DeliverySiteOnboardingResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {
            customer_business_name: customerBusinessName,
            name: deliverySiteOnboardingRequest.name,
            address: deliverySiteOnboardingRequest.address,
            city: deliverySiteOnboardingRequest.city,
            postal_code: deliverySiteOnboardingRequest.postalCode,
            jurisdiction: deliverySiteOnboardingRequest.jurisdiction,
            zone: deliverySiteOnboardingRequest.zone,
            preferred_delivery_time_range: deliverySiteOnboardingRequest.preferredDeliveryTimeRange,
            exceptional_frequency: deliverySiteOnboardingRequest.exceptionalFrequency,
        }, responseHandler);
    }

    getDeliverySiteOnboarding(deliverySiteOnboardingId, responseHandler) {
        const endpoint = new Endpoint({
            url: `delivery-site-onboarding/${deliverySiteOnboardingId}`,
            method: "GET",
            ownResponses: [DeliverySiteOnboardingResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    editDeliverySiteOnboarding(deliverySiteOnboardingId, deliverySiteOnboardingRequest, responseHandler) {
        const endpoint = new Endpoint({
            url: "delivery-site-onboarding/edit",
            method: "POST",
            ownResponses: [DeliverySiteOnboardingResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {
            delivery_site_onboarding_external_id: deliverySiteOnboardingId,
            name: deliverySiteOnboardingRequest.name,
            address: deliverySiteOnboardingRequest.address,
            city: deliverySiteOnboardingRequest.city,
            postal_code: deliverySiteOnboardingRequest.postalCode,
            jurisdiction: deliverySiteOnboardingRequest.jurisdiction,
            zone: deliverySiteOnboardingRequest.zone,
            preferred_delivery_time_range: deliverySiteOnboardingRequest.preferredDeliveryTimeRange,
            exceptional_frequency: deliverySiteOnboardingRequest.exceptionalFrequency,
        }, responseHandler);
    }

    editOrCreateDeliverySiteOnboardingAuthorizations(deliverySiteOnboardingId, responseHandler) {
        const endpoint = new Endpoint({
            url: "delivery-site-onboarding/authorizations/edit-or-create",
            method: "POST",
            ownResponses: [DeliverySiteOnboardingResponse, UserDoesNotHaveRequiredPermissionErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {
            delivery_site_onboarding_external_id: deliverySiteOnboardingId,
        }, responseHandler);
    }

    userWithRolesAndPermissionsGranted(responseHandler, anEmail) {
        const url = `users/${anEmail}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [UserResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    customerOnboardings(responseHandler) {
        const endpoint = new Endpoint({
            url: "customer-onboardings",
            method: "GET",
            ownResponses: [CustomerOnboardingsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    getCustomerOnboarding(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: `customer-onboarding/${taxpayerIdentificationNumber}`,
            method: "GET",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    updateCustomerOnboardingState(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: `customer-onboarding/update/state`,
            method: "POST",
            ownResponses: [CustomerOnboardingResponse, UpdateCustomerOnboardingStateErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {"taxpayer_identification_number": taxpayerIdentificationNumber}, responseHandler);
    }

    editOrCreateCustomerOnboardingAuthorizations(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: `customer-onboarding/authorizations/edit-or-create`,
            method: "POST",
            ownResponses: [CustomerOnboardingResponse, UpdateCustomerOnboardingStateErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {"taxpayer_identification_number": taxpayerIdentificationNumber}, responseHandler);
    }

    createCustomerOnboarding(responseHandler, taxpayerIdentificationNumber) {
        const endpoint = new Endpoint({
            url: "customer-onboarding/create",
            method: "GET",
            ownResponses: [CustomerOnboardingResponse, CreateCustomerOnboardingErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {"taxpayer_identification_number": taxpayerIdentificationNumber}, responseHandler);
    }

    editLegalEntity(legalEntity, responseHandler) {
        const endpoint = new EditCustomerOnboardingLegalEntityEndpoint({
            url: "customer-onboarding/legal-entity/edit",
            method: "POST",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, legalEntity, responseHandler);
    }

    editContactData(taxpayerIdentificationNumber, contactData, responseHandler) {
        const endpoint = new EditCustomerOnboardingContactDataEndpoint({
            url: "customer-onboarding/contact-data/edit",
            method: "POST",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, contactData}, responseHandler);
    }

    async editTaxData(taxpayerIdentificationNumber, taxData, responseHandler) {
        const formData = new FormData();
        formData.append('taxpayer_identification_number', taxpayerIdentificationNumber);
        const fileFields = [
            ['afipRegistrationProof', 'afip_registration_proof'],
            ['grossIncomeTaxRegistrationProof', 'gross_income_tax_registration_proof'],
            ['cm01form', 'cm01_form'],
            ['cm05form', 'cm05_form'],
            ['exemptionsCertificate', 'exemptions_certificate'],
            ['nonWithholdingCertificate', 'non_withholding_certificate'],
        ];
        const preserveFileKeys = await this._appendFileFieldsToFormData(formData, fileFields, taxData);
        formData.append('preserve_file_keys', JSON.stringify(preserveFileKeys));
        formData.append('raw_income', taxData.rawIncome);
        formData.append('exemption_certificate_option', taxData.exemptionCertificateOption);
        formData.append('provinces_perceptions', taxData.provincesPerceptions);
        formData.append('non_withholding_certificate_option', taxData.nonWithholdingCertificateOption);
        formData.append('income_tax', taxData.incomeTax);
        formData.append('iva_condition', taxData.ivaCondition);

        return await this.callEndpointWithFiles(
            '/customer-onboarding/tax-data/edit', 'POST', formData, CustomerOnboardingResponse, responseHandler
        );
    }

    async editFinanceData(taxpayerIdentificationNumber, taxData, responseHandler) {
        // FIXME: MISSING IMPLEMENTATION IN ERYXCOM PACKAGE.
        const formData = new FormData();
        formData.append('taxpayer_identification_number', taxpayerIdentificationNumber);
        formData.append('finance_observations', taxData.financeObservations);

        const fileFields = [['nosisDocument', 'nosis_document_file']];
        const preserveFileKeys = await this._appendFileFieldsToFormData(formData, fileFields, taxData);

        formData.append('preserve_file_keys', JSON.stringify(preserveFileKeys));
        const endpointUrl = `/customer-onboarding/finance-data/edit`;
        const method = 'POST';
        const responseClass = CustomerOnboardingResponse;

        return await this.callEndpointWithFiles(endpointUrl, method, formData, responseClass, responseHandler);
    }

    editCommercialTerms(taxpayerIdentificationNumber, commercialTerms, responseHandler) {
        const endpoint = new EditCustomerOnboardingCommercialTermsEndpoint({
            url: "customer-onboarding/commercial-terms/edit",
            method: "POST",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, commercialTerms}, responseHandler);
    }

    editOrCreateDeliverySitesOnboardingRequests(taxpayerIdentificationNumber, deliverySiteOnboardingRequest, responseHandler) {
        const endpoint = new EditOrCreateCustomerOnboardingDeliverySiteOnboardingRequestEndpoint({
            url: "customer-onboarding/delivery-site-onboarding-requests/edit-or-create",
            method: "POST",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, deliverySiteOnboardingRequest}, responseHandler);
    }

    deleteDeliverySiteOnboardingRequest(deliverySiteOnboardingRequestId, responseHandler) {
        const endpoint = new Endpoint({
            url: "delivery_site_onboarding_request/delete",
            method: "POST",
            ownResponses: [],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'delivery_site_onboarding_request_external_id': deliverySiteOnboardingRequestId}, responseHandler);
    }

    editOrCreateUserOnboardingRequests(taxpayerIdentificationNumber, userOnboardingRequest, responseHandler) {
        const endpoint = new EditOrCreateCustomerOnboardingUserRequestEndpoint({
            url: "customer-onboarding/user-onboarding-requests/edit-or-create",
            method: "POST",
            ownResponses: [CustomerOnboardingResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayerIdentificationNumber, userOnboardingRequest}, responseHandler);
    }

    deleteUserOnboardingRequest(userOnboardingRequestId, responseHandler) {
        const endpoint = new Endpoint({
            url: "user_onboarding_request/delete",
            method: "POST",
            ownResponses: [],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {'user_onboarding_request_external_id': userOnboardingRequestId}, responseHandler);
    }

    /**
     * Reutilizable: dado un formData, una lista [jsKey, formKey] y el objeto data,
     * solo agrega al formData los File nuevos; devuelve la lista de formKeys a preservar (existentes con url+name).
     */
    async _appendFileFieldsToFormData(formData, fileFields, data) {
        const preserveKeys = [];
        for (const [jsKey, formKey] of fileFields) {
            const value = data[jsKey];
            const file = await this._ensureFile(value);
            if (file instanceof File) {
                formData.append(formKey, file);
            } else if (value?.url && value?.name) {
                preserveKeys.push(formKey);
            }
        }
        return preserveKeys;
    }

    async _ensureFile(value) {
        if (value instanceof File) return value;
        if (value?.url && value?.name) return null; // existente: se conserva vía preserve_file_keys
        return null;
    }

    async callEndpointWithFiles(endpointUrl, method, formData, responseClass, responseHandler) {
        // FIXME: this should be replaced with a proper use of ERYXCOM package when it handles multiple files
        const token = this._application.session().getToken();
        const headers = {
            'Authorization': `Bearer ${token}`,
        }

        const response = await this._requester.callUrlWithFormDataWithFiles(method, formData, headers, endpointUrl)

        if (response.status === 200) {
            const responseData = await response.json();
            const successResponse = new responseClass(responseData);
            responseHandler._handlesSuccess(successResponse);
        } else {
            responseHandler._handlesError(response);
        }
        return response;
    }

    orderPrices(orderId, responseHandler) {
        const url = `order/prices/${orderId}`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [OrderPricesResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    orderAdvancePaymentProof(orderId, responseHandler) {
        const url = `order/${orderId}/advance-payment-proof/`
        const endpoint = new Endpoint({
            url: url,
            method: "GET",
            ownResponses: [OrderAdvancePaymentProofResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    createLead(lead, responseHandler) {
        const endpoint = new CreateLeadEndpoint({
            url: "lead/create",
            method: "POST",
            ownResponses: [LeadResponse, CreateLeadErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, lead, responseHandler);
    }

    possibleDuplicateLeads(lead, responseHandler) {
        const endpoint = new PossibleDuplicateLeadsEndpoint({
            url: "lead/possible-duplicates",
            method: "POST",
            ownResponses: [PossibleDuplicateLeadsResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, lead, responseHandler);
    }

    markAndNotifyPossibleDuplicateLead(leadId, responseHandler) {
        const endpoint = new Endpoint({
            url: "lead/possible-duplicate/mark-and-notify",
            method: "POST",
            ownResponses: [LeadResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {lead_id: leadId}, responseHandler);
    }

    horecaLeadAssignmentQueue(responseHandler) {
        const endpoint = new Endpoint({
            url: "lead/horeca-assignment-queue",
            method: "GET",
            ownResponses: [LeadAssignmentQueueResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {}, responseHandler);
    }

    assignLead(leadAssignment, responseHandler) {
        const endpoint = new AssignLeadEndpoint({
            url: "lead/assign",
            method: "POST",
            ownResponses: [LeadResponse, AssignLeadErrorResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, leadAssignment, responseHandler);
    }

    deliveryZoneForCoordinates(latitude, longitude, responseHandler) {
        const endpoint = new Endpoint({
            url: "logistics/delivery-zone",
            method: "GET",
            ownResponses: [DeliveryZoneResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {latitude, longitude}, responseHandler);
    }

    leadTaxpayerIdentificationNumberValidation(taxpayerIdentificationNumber, responseHandler) {
        const endpoint = new Endpoint({
            url: "lead/taxpayer-identification-number-validation",
            method: "GET",
            ownResponses: [LeadTaxpayerIdentificationNumberValidationResponse],
            needsAuthorization: true
        });
        return this.callEndpoint(endpoint, {taxpayer_identification_number: taxpayerIdentificationNumber}, responseHandler);
    }

    askBackofficeAssistant(userRequest, chatHistory, responseHandler) {
        const endpoint = new Endpoint({
            url: "assistant/backoffice/ask",
            method: "POST",
            ownResponses: [AskBackofficeAssistantResponse],
            needsAuthorization: true
        });

        return this.callEndpoint(endpoint, {
            user_request: userRequest,
            chat_history: chatHistory
        }, responseHandler);
    }
}
